import React from "react";
import ReactDOM from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "./ui/antd";
import { lucideComponentDefaults } from "./ui/antd";
import { XProvider } from "@ant-design/x";
import zhCN from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import App from "./App";
import CustomerChatTest from "./pages/CustomerChatTest";
import "./styles.css";
import "./typography.css";
import "./antd-react-render";
import { redirectLocalHttps } from "./local-https-entry";

if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

void redirectLocalHttps(window.location).then(redirected => {
if (redirected) return;
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ConfigProvider {...lucideComponentDefaults} locale={zhCN} theme={{
      token: {
        colorPrimary: "#0f766e", borderRadius: 12,
        fontFamily: "var(--web-font-family)", fontSize: 14, fontSizeSM: 13, fontWeightStrong: 500,
      },
      components: { Button: { fontWeight: 500, contentFontSizeSM: 13 }, Tag: { fontSizeSM: 12 } },
    }}>
      <XProvider>
        <AntdApp>{window.location.pathname.replace(/\/$/, "") === "/customer-chat-test" ? <CustomerChatTest /> : <App />}</AntdApp>
      </XProvider>
    </ConfigProvider>
  </React.StrictMode>
);
});
